import styles from './ContactUsDealerInformationSection.module.scss';
import { CatCard } from '@blocks-react/components/Card';
import { useSelector } from 'react-redux';
import ContactUsDealerInformationSectionSkeleton from './ContactUsDealerInformationSectionSkeleton';
import ContactUsDealerInformationSectionHeader from './ContactUsDealerInformationSectionHeader';
import ContactUsDealerInformationSectionStoreInfo from './ContactUsDealerInformationSectionStoreInfo';
import ContactUsDealerInformationFooter from './ContactUsDealerInformationFooter';
import { PAGE_BREAKPOINTS } from '@app/constants/commonConstants';
import { useBreakpoint } from '@app/hooks';

const ContactUsDealerInformationSection = () => {
  const isMD = useBreakpoint(PAGE_BREAKPOINTS.MD);
  const isLoadingContactUsPage = !useSelector(
    s => s.dealer?.getDealerInfoSuccess
  );

  return (
    <div className={styles['contactUsPage__dealerInformationSection']}>
      <div>
        <CatCard>
          <div slot="header">
            {!isLoadingContactUsPage && (
              <ContactUsDealerInformationSectionHeader />
            )}
          </div>
          {!isLoadingContactUsPage ? (
            <ContactUsDealerInformationSectionStoreInfo />
          ) : (
            <ContactUsDealerInformationSectionSkeleton />
          )}
          {isMD && !isLoadingContactUsPage && (
            <div slot="footer">
              <ContactUsDealerInformationFooter />
            </div>
          )}
        </CatCard>
      </div>
    </div>
  );
};

export default ContactUsDealerInformationSection;
